module.exports = __webpack_public_path__ + "img/logo.28297b03.svg";